import {
	getHolidaysService,
	updateHolidayService,
	getHolidayByIdService,
	deleteHolidayService,
	createHolidayService
} from '../storeServices/holidayService'

export default {
	namespaced: true,
	state: {
		holidays: [],
		selectedHoliday: null,
		updateStatusOptions: [
			{ text: '1. Cita', value: '1. Cita' },
			{ text: 'Not Apply - selfinspection', value: 'Not Apply - selfinspection' },
		],
		holidayCount: 0,
		checkValidation: false,
		holidayForm: null,
	},
	getters: {
	},
	mutations: {
		setHolidays(state, payload) {
			state.holidays = payload.items
			state.holidayCount = payload.meta.totalItems
		},
		setSelectedHoliday(state, payload) {
			state.selectedHoliday = payload
		},
		setHolidayForm(state, payload) {
			state.holidayForm = payload
		},
	},
	actions: {
		async getHolidays({ state, commit, rootState }, payload) {
			const { date, actualPage, pageQuantity, selectedStatus } = rootState.tableFilters
			try {
				const serviceResponse = await getHolidaysService({ date, page: actualPage, limit: pageQuantity, status: selectedStatus })
				commit('setHolidays', serviceResponse.data)
				return serviceResponse
			} catch (e) {
				console.log(e)
				return e
			}
		},
		async getHolidayById({ state, commit, rootState }, payload) {
			const { selectedHoliday } = state
			const serviceResponse = await getHolidayByIdService({ holidayId: selectedHoliday.id })
			commit('setSelectedHoliday', serviceResponse.data)
			return serviceResponse
		},
		async deleteHoliday({ state, commit, rootState }, payload) {
			const serviceResponse = await deleteHolidayService(payload)
			return serviceResponse
		},
		async updateHolidays({ state, commit }, payload) {
			const { create } = payload
			const holiday = state.holidayForm
			try{

			const { morningDisponibility, eveningDisponibility, initialTime, initialDate, finalDate, finalTime, lunchTime, isAllDay, locations, description } = holiday
			let allDay
			if(isAllDay === 'true'){
				allDay = true
			}else{
				allDay = false
			}
			const updatedHoliday = {
				morningDisponibility,
				eveningDisponibility,
				initialTime,
				lunchTime,
				finalTime,
				initialDate,
				finalDate,
				isAllDay: allDay,
				locations,
				description
			}
				console.log(updatedHoliday)
				if(!create){
					/* const holiday = state.selectedHoliday
					const serviceResponse = await updateHolidayService({ holidayId: holiday.id, updatedHoliday })
					return serviceResponse */
				}else{
					const serviceResponse = await createHolidayService({ updatedHoliday })
					return serviceResponse
				}
			}catch(e){
				console.log(e)
			}
		}
	},
}
